// Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved.

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { catchError } from 'rxjs/operators';
import { API_URL } from 'src/shared/api';

// This import exists to reuse the handle error function.
import { D3eService } from './d3e-service';
import {ConfigurationService} from './configuration-service';

// These match what are on the API side
export type Actions = 'download' |
    'download_free' |
    'copy_url' |
    'copy_activation' |
    'download_pba' |
    'download_msi' |
    'download_win_fde' |
    'download_ubuntu_fde' |
    'download_rhel_fde' |
    'download_win_cli' |
    'download_ubuntu_cli' |
    'download_rhel_cli' |
    'download_win_agent_exe' |
    'download_win_agent_msi' |
    'download_ubuntu_agent' |
    'download_rhel_agent' |
    'copy_msi_command';

@Injectable({providedIn: 'root'})
export class ActionService {
  
    constructor(
      private http: HttpClient,
      private translate: TranslateService,
      private d3eService: D3eService,
      private configurationService: ConfigurationService,
    ) { }

    getUrl(suffix: string) {
        return `${this.configurationService.apiUrl}${suffix}`;
    }

    // The filename is mandatory.  The email is not mandatory except
    // in cases where no authorization token exists.
    // <p>
    // If the call is being made from a page without authorization
    // (such as the d3e subscription page), the email must be provided.
    // If the user is authorized, the email obtained from the 
    // authorized user will override any passed in value.  
    postDownload(filename: string, action: Actions, email: string, uuid: string) {
        const body = { 'action': action, 'filename' : filename, 'email': email, 'subscription_uuid': uuid  };
        this.console_post_action(body).subscribe();
    }

    postDownloadBySubUUID(filename: string, uuid: string, action = 'download') {
        const url = this.getUrl(API_URL.API_TRACK_DOWNLOAD);
        const body = { 'action': action, 'filename' : filename, 'subscription_uuid': uuid };
        return this.http.post(url, body);
    }

    console_post_action(body: object) {
        const url = this.getUrl(API_URL.API_TRACK_ACTION);
        return this.http.post(url, body)
        .pipe(catchError(this.d3eService.handleError.bind(this)));
    }

}
